module.exports = __webpack_public_path__ + "img/Plug.3a0d49fc.png";